import { useTranslation } from 'react-i18next'

import { useDeviceReferral } from '@pages/Referral/DeviceReferral'

import { Button } from '@ui/components/Button'

import { LeadDto } from '@model/LeadDto'

import {
  StatusTemplateBody,
  StatusTemplateButtons,
  StatusTemplateWrapper,
} from '@shared/templates/StatusTemplate/StatusTemplate'

interface MobileAppRedirectSuccessPageProps {
  lead?: LeadDto
}

const MobileAppRedirectSuccessPage: React.FC<MobileAppRedirectSuccessPageProps> = (props) => {
  const { lead } = props
  const { referralAppLink } = useDeviceReferral()

  const { t } = useTranslation()

  const goToMobileApp = () => {
    if (lead) {
      window.location.href = referralAppLink({
        id: lead.id,
        token: lead.token,
        type: 'register',
      })
    }
  }

  return (
    <StatusTemplateWrapper>
      <StatusTemplateBody
        title={t('Sign up.Your email has been verified!')}
        text={[t('Sign up.Please continue your registration by going back to the mobile app.')]}
        icon={'Success'}
      />
      <StatusTemplateButtons>
        <Button.Primary size='lg' fullWidth onClick={goToMobileApp}>
          {t('Sign up.Back to the app')}
        </Button.Primary>
      </StatusTemplateButtons>
    </StatusTemplateWrapper>
  )
}

export default MobileAppRedirectSuccessPage
